'use strict';

module.exports = 0xff19;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/var/FULL_WIDTH_NINE.js
// module id = 431
// module chunks = 0